import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientMedicationScreen } from 'screens/patient';

export default withPermissions(PatientMedicationScreen, [
  GroupSecurity.MedicationStatementRead,
]);
